// ==============================|| ROLE WEIGHTS / MODULE ACCESS ||============================== //
// Single source of truth for the 5 RBAC levels (2026-08-22 - previously
// duplicated separately in Roles.jsx and Groups.jsx) and for deciding
// "does this user see this section" generically - mirrors the backend's
// PermissionService::ROLE_WEIGHTS (src/Core/Auth/PermissionService.php)
// exactly, including the superadmin (system/admin) bypass that
// PushAuthorizer/RequireGroupAdminMiddleware already use server-side.

export const ROLE_LEVELS = [
  { value: 'reader', label: 'čtenář' },
  { value: 'editor', label: 'editor' },
  { value: 'regional_manager', label: 'oblastní manažer' },
  { value: 'manager', label: 'hlavní manažer' },
  { value: 'admin', label: 'správce' }
];

const ROLE_WEIGHTS = ROLE_LEVELS.reduce((acc, level, index) => ({ ...acc, [level.value]: index + 1 }), {});

function weightOf(role) {
  return ROLE_WEIGHTS[role] ?? 0;
}

/**
 * True if `permissions` (the array /auth/me returns - list of
 * {module_key, widget_key, role, source}) grants at least `minRole` on
 * `moduleKey`. Superadmin (system/admin) always passes, for any
 * moduleKey/minRole - same bypass the backend applies everywhere
 * (PushAuthorizer::canSendToGroup(), RequireGroupAdminMiddleware, etc.).
 */
export function hasModuleAccess(permissions, moduleKey, minRole) {
  if (!Array.isArray(permissions)) return false;

  const isSuperAdmin = permissions.some((p) => p.module_key === 'system' && weightOf(p.role) >= ROLE_WEIGHTS.admin);
  if (isSuperAdmin) return true;

  const minWeight = ROLE_WEIGHTS[minRole] ?? Infinity;
  return permissions.some((p) => p.module_key === moduleKey && weightOf(p.role) >= minWeight);
}
